import { Chip } from '@mui/material'
import { IPADUCompiledField } from '../../definitions/Contract'

interface P {
    compiledPADU: IPADUCompiledField
}

const PADUChip = ({ compiledPADU }: P) => {
    if (!compiledPADU || compiledPADU.status === 'none') return null

    const { status } = compiledPADU
    return (
        <Chip
            label={status?.[0].toUpperCase()}
            sx={{ fontWeight: 500 }}
            size='small'
            variant='filled'
            color={status === 'preferred' ? 'success' : status === 'acceptable' ? 'primary' : status === 'discouraged' ? 'warning' : 'error'}
        />
    )
}

export default PADUChip
